import React from 'react';
import { STATUS_COLOR_PALETTE } from './statusColorPalette';

/**
 * Mapeamento dos rótulos em pt-BR para cada status de Processo Seletivo (PSP).
 */
export const selectionProcessStatusLabels = {
    em_breve: 'Em breve',
    inscricao: 'Período de Inscrição',
    inscricao_encerrada: 'Inscrições Encerradas',
    provas: 'Etapa de Provas',
    analise_resultados: 'Análise de Resultados',
    documentos: 'Envio de Documentos',
    resultado_parcial: 'Resultado Parcial',
    resultado_final: 'Resultado Final'
};

const statusColors = {
    em_breve: STATUS_COLOR_PALETTE.grey,
    inscricao: STATUS_COLOR_PALETTE.green,
    inscricao_encerrada: STATUS_COLOR_PALETTE.yellow,
    provas: STATUS_COLOR_PALETTE.blue,
    analise_resultados: STATUS_COLOR_PALETTE.purple,
    documentos: STATUS_COLOR_PALETTE.teal,
    resultado_parcial: STATUS_COLOR_PALETTE.orange,
    resultado_final: STATUS_COLOR_PALETTE.dark
};

/**
 * Retorna a formatação de célula de status para Processos Seletivos (PSP),
 * exibindo uma bolinha colorida (dot indicator) alinhada ao texto do status.
 */
export const selectionProcessStatusCell = (row) => {
    const color = statusColors[row.status] || STATUS_COLOR_PALETTE.grey;
    const label = selectionProcessStatusLabels[row.status] || row.status || '-';

    return (
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span
                style={{
                    display: 'inline-block',
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    backgroundColor: color,
                    flexShrink: 0
                }}
            />
            {label}
        </span>
    );
};
